import React, {useCallback, useEffect, useState} from "react";
import {useDropzone} from 'react-dropzone';
import {formatBytes} from "helpers/fileManager";
import ButtonList from "../Elements/ButtonGroup";
import {useDispatch} from "react-redux";
import {Link} from "@material-ui/core";
import {makeStyles} from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
    },
    acceptedFiles: {
        fontSize: '12px',
        padding: '0px',
        margin: '0px',
    },
    container: {
        position: 'absolute',
        zIndex: '55',
        top: '-1px',
        background: '#f6f7fd',
        border: '1px solid #868DAA',
        borderTop: 'none',
        borderRadius: '0px 0px 5px 5px',
        padding: '20px 40px',
        margin: '0px 0px 0px 50px',
        '& .dropzone': {
            flex: "1",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            padding: "50px 20px",
            borderWidth: "2px",
            borderRadius: "2px",
            borderStyle: "dashed",
            backgroundColor: "#fff",
            margin: '10px 0px',
            color: "#bdbdbd",
            cursor: "pointer",
            outline: "none",
            transition: "border .24s ease-in-out",
            '&:focus': {
                borderColor: theme.palette.primary.main
            },
            '& p': {
                padding: '0px',
                margin: '0px',
            }
        }
    }
}));

export default function UploadFiles({handleCancel, currentFolder, handleReload, uploadFile}) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const [files, setFiles] = useState([]);

    const onDrop = useCallback(acceptedFiles => {
        console.log('acceptedFiles', acceptedFiles);
        setFiles(acceptedFiles.map(file => Object.assign(file, {
            preview: window.URL.createObjectURL(file)
        })));
    }, [])

    const {getRootProps, getInputProps} = useDropzone({onDrop});

    const removeFile = index => {
        let newFiles = [...files];
        newFiles.splice(index, 1);
        console.log(newFiles, files);
        setFiles(newFiles);
    };

    const acceptedFiles = files.map((file, index) => (
        <li key={file.path}>
            {file.name} - {formatBytes(file.size)} ( <Link style={{cursor: 'pointer'}}
                                                           onClick={() => removeFile(index)}><span>Remove</span></Link>)
        </li>
    ));

    const handleSubmitUpload = () => {
        let formData = new FormData();
        formData.append('path', currentFolder);
        files.forEach((file, index) => {
            formData.append('files', file, file.name);
        });
        dispatch(uploadFile(formData)).then((result) => {
            handleReload();
            handleCancel();
        });
    };

    const handleCancelUpload = () => {
        handleCancel();
    }

    const buttons = [
        {
            name: 'submit',
            icon: 'icon-save',
            label: 'Upload',
            class: 'green',
            onClick: handleSubmitUpload,
            disabled: !(files.length > 0)
        },
        {
            name: 'submit',
            icon: 'icon-ban',
            label: 'Cancel',
            type: 'link',
            onClick: handleCancelUpload
        }
    ];

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach(file => window.URL.revokeObjectURL(file.preview));
    }, [files]);

    return (
        <section className={classes.container}>
            <div {...getRootProps({className: 'dropzone'})}>
                <input {...getInputProps()} />
                <p>Drag 'n' drop some files here, or click to select files</p>
            </div>
            <ul className={classes.acceptedFiles}>
                {acceptedFiles}
            </ul>
            <ButtonList buttons={buttons}/>
        </section>
    )
}